export default __webpack_public_path__ + "static/media/whatsappSlide1.db541a7f.svg";